import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getRevenue',
    standalone: true
})
export class GetRevenuePipe implements PipeTransform {

    transform(value: any, ...args: unknown[]): unknown {
        if (value && !isNaN(value)) {
            let revenueValue;
            let revenuePrevifx;
            if (value >= 1000) {
                revenueValue = (value / 1000);
                if (revenueValue.toFixed(1).split('.')[1] === '0') {
                    revenueValue = revenueValue.toFixed(0);
                } else {
                    revenueValue = revenueValue.toFixed(1);
                }
                revenuePrevifx = 'B';
            } else {
                revenueValue = value;
                revenuePrevifx = 'M';
            }
            revenueValue = parseFloat(revenueValue);
            return revenueValue.toLocaleString() + '' + revenuePrevifx;
        } else {
            return '';
        } 
    }

}
